import { Radio, Tooltip } from 'antd';
import { FlexRow } from '../../../components/common/common';
import { QuestionCircleOutlined, VideoCameraOutlined, FieldTimeOutlined } from '@ant-design/icons';
import { SenseMode } from '../../../types/types';

type SenseTabProps = {
  isRecording: boolean;
  senseMode: SenseMode;
  setSenseMode: React.Dispatch<React.SetStateAction<SenseMode>>;
  setIsPlanModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
};

const SenseTab: React.FC<SenseTabProps> = ({ isRecording, senseMode, setSenseMode, setIsPlanModalOpen }) => {
  return (
    <FlexRow
      style={{
        width: '100%',
        justifyContent: 'center',
        alignItems: 'center',
        gap: 5,
      }}
    >
      <Radio.Group
        disabled={isRecording}
        optionType="button"
        buttonStyle="solid"
        size="large"
        value={senseMode}
        options={[
          {
            label: (
              <>
                <Tooltip overlay="Freely record samples">
                  <VideoCameraOutlined /> Manual acquisition
                </Tooltip>
              </>
            ),
            value: SenseMode.Recording,
          },
          {
            label: (
              <>
                <Tooltip overlay="Record samples according to predefined plan">
                  <FieldTimeOutlined /> Timed acquisition
                </Tooltip>
              </>
            ),
            value: SenseMode.TimedRecording,
          },
          {
            label: (
              <>
                <Tooltip overlay="Question unknown samples for odor recognition">
                  <QuestionCircleOutlined /> Recognition
                </Tooltip>
              </>
            ),
            value: SenseMode.Questionning,
          },
        ]}
        onChange={(e) => {
          setSenseMode(e.target.value);
          if (e.target.value === SenseMode.TimedRecording) {
            setIsPlanModalOpen(true);
          }
        }}
      />
    </FlexRow>
  );
};

export default SenseTab;
